import { Editor } from '@tiptap/react'
import { Popover } from 'antd'
import { useState } from 'react'

import { BracesVariables } from '@/ui/Icons'
import cn from '@/utils/tailwind/cn'

type Props = {
  editor: Editor
}

export const TextEditorToolbarVariables = ({ editor }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const closePopover = () => setIsOpen(false)

  const addVariables = (value: string) => {
    editor
      .chain()
      .focus()
      .insertContent({
        type: 'variable',
        attrs: {
          name: value,
        },
      })
      .run()
  }

  const variableList = [
    {
      id: 'first-name',
      label: 'First Name',
      icon: null,
      onClick: () => addVariables('firstName'),
    },
    {
      id: 'last-name',
      label: 'Last Name',
      icon: null,
      onClick: () => addVariables('lastName'),
    },
    {
      id: 'team-name',
      label: 'Team Name',
      icon: null,
      onClick: () => addVariables('teamName'),
    },
  ]

  return (
    <Popover
      classNames={{ body: '!px-0' }}
      content={
        <div className="flex w-full flex-col items-center">
          {variableList.map((item) => {
            const isActive = editor.isActive(item.id)
            return (
              <button
                className={cn(
                  'flex w-full items-center justify-start gap-2 rounded-sm border-2 border-transparent bg-transparent py-1.5 pl-2.5 pr-10 text-base outline-none hover:!bg-gray-100 focus:outline-none disabled:cursor-not-allowed',
                  isActive && 'bg-gray-100 text-primary'
                )}
                key={item.id}
                onClick={() => {
                  item.onClick()
                  closePopover()
                }}
                type="button"
              >
                {item.icon} {item.label}
              </button>
            )
          })}
        </div>
      }
      getPopupContainer={() => document.body}
      onOpenChange={() => setIsOpen((old) => !old)}
      open={isOpen}
      placement="bottom"
      trigger="click"
    >
      <button
        className="flex h-6 items-center justify-center gap-1 rounded-sm border-2 border-transparent bg-transparent p-0 text-lg outline-none hover:text-primary focus:outline-none disabled:cursor-not-allowed"
        type="button"
      >
        <BracesVariables className="fill-gray-600" width={24} />
      </button>
    </Popover>
  )
}
